import React from "react";
import {useTranslation} from "react-i18next";
import Modal from "./Modal";
import {isCart, useUnsafeCartContext} from "../../cart/CartContextProvider/CartContextProvider";

interface IAddToCartProps {
  closeFunction: () => void;
  isVisible: boolean;
  itemIds: number[];
  toCartFunction: () => void;
}

const AddToCartModal: React.FC<IAddToCartProps> = (props) => {
  const {t} = useTranslation("cart");
  const context = useUnsafeCartContext();
  const {itemIds} = props;

  if (!itemIds || !isCart(context)) {
    return null;
  }

  const positions = context.cart.positions.filter((pos) => {
    return (
      pos.type === "Item" &&
      pos.reference &&
      pos.reference.itemId !== null &&
      pos.item &&
      itemIds.includes(pos.item.itemId)
    );
  });

  const Content: React.FC = () => (
    <div className="content">
      <table style={{margin: "0 0 1rem"}}>
        <tbody>
          {positions.map((pos) => {
            if (!pos.item) {
              return;
            }
            const imgUrl = pos.item.images[0].sizes.find((img) => img.name === "thumbnail-3x")?.url;

            return (
              <tr key={pos.item.itemId}>
                <td style={{width: "98px"}}>
                  <img src={imgUrl} alt={pos.item.title} width="90px" />
                </td>
                <td>{t("{{title}} wurde in Ihren Warenkorb gelegt.", {title: pos.item.title})}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  const toCart = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    evt.preventDefault();
    props.toCartFunction();
  };

  return (
    <Modal isVisible={props.isVisible} closeFunction={props.closeFunction}>
      <React.Fragment>
        <h2>{t("Gute Wahl!")}</h2>
        <Content />
        <a href="#" onClick={toCart} className="button">
          {t("Zum Warenkorb")}
        </a>
      </React.Fragment>
    </Modal>
  );
};

export default AddToCartModal;
